<template>
	<AppPage>
		<AppPageHeader
			title="HDN Berichten"
			description="Alle berichten voor deze aanvraag"
			:back-link
		/>

		<div class="p-8 max-w-[1000px] w-full mx-auto">
			<Suspense>
				<LoanApplicationMessages
					v-if="dossierId && loanApplicationId"
					:loan-application-id="loanApplicationId"
					:dossier-id="dossierId"
				/>
			</Suspense>
		</div>
	</AppPage>
</template>

<script lang="ts" setup>
import { useDossierStore } from "@/store/useDossierStore";
import { computed } from "vue";
import { useRouteParams } from "@vueuse/router";

const backLink = {
	label: "Terug naar overzicht",
	to: { name: "LoanApplicationDetailsPage" },
};

const dossierStore = useDossierStore();

const dossierId = computed(() => dossierStore.selectedDossier?.id);
const loanApplicationId = useRouteParams<null | string>("loanApplicationId");
</script>
